const dev = {
  cognito: {
    region: "eu-west-1",
    userPool: "eu-west-1_oB9HhVl4s",
    identityPool: "eu-west-1:8017e8dc-f96a-4733-ab34-03a51b62a514",
    clientId: "7k0t7pi7a94hdkbp3du4ktem5l",
    bucketName: "mmk-galaxy-users",
    interviewBucketName:'mmk-galaxy-interview-scheduler-dev',
    cvParseBucketName : 'mmk-galaxy-cv-dev'
  },
  apiUrl: "https://1pyjflj7ej.execute-api.eu-west-1.amazonaws.com/Stage/",
  intercomAppId: "pij3591y",
  GAId: "UA-129662805-1"
};

const uat = {
  cognito: {
    region: "eu-west-1",
    userPool: "eu-west-1_fYJPGU6TY",
    identityPool: "eu-west-1:523ed03f-2bcd-4835-90e6-55935f959044",
    clientId: "3p04573h9lf0h71ajh2kialba6",
    bucketName: "mmk-galaxy-users-uat",
    interviewBucketName:'mmk-galaxy-interview-scheduler-uat',
    cvParseBucketName : 'mmk-galaxy-cv-uat'
  },
  apiUrl: "https://y784cychr0.execute-api.eu-west-1.amazonaws.com/Stage/",
  intercomAppId: "pij3591y",
  GAId: "UA-129662805-3"
};

const prod = {
  cognito: {
    region: "eu-west-1",
    userPool: "eu-west-1_VGVYTwEvp",
    identityPool: "eu-west-1:8e9fca1b-1e2b-4079-b4ab-cf1f28aeb9bf",
    clientId: "2srmh8rgqr5q86stqdvideer93",
    bucketName: "mmk-galaxy-users-prod",
    interviewBucketName:'mmk-galaxy-interview-scheduler-prod',
    cvParseBucketName : 'mmk-galaxy-cv-prod'
  },
  apiUrl: "https://tykg7u00l1.execute-api.eu-west-1.amazonaws.com/Stage/",
  intercomAppId: "pij3591y",
  GAId: "UA-129662805-2"
};

const config = (process.env.REACT_APP_STAGE === 'production')
  ? prod
  : (process.env.REACT_APP_STAGE === 'uat') 
  ? uat 
  : dev;

export default {
  // Add common config values here
  // MAX_ATTACHMENT_SIZE: 5000000,
  InterviewSchedulerFilter: "rcave@morganmckinley.ie, rcave@premiergp.com, traceyoneill@morganmckinley.ie, traceyoneill@premiergp.com, apm@premiergp.com, apm@morganmckinley.in, ss@premiergp.com, ss@morganmckinley.in, vnair@premiergp.com, vnair@morganmckinley.in, skumar@premiergp.com, skumar@morganmckinley.in, pgeorge@premiergp.com, pgeorge@morganmckinley.in, spandian@premiergp.com, spandian@morganmckinley.in, apurushothaman@premiergp.com, apurushothaman@morganmckinley.in, taraoneill@morganmckinley.com, taraoneill@morganmckinley.ie",
  reportFilter:"jdonegan@premiergp.com, apm@morganmckinley.in, apm@premiergp.com, apm@morganmckinley.com, ccostello@morganmckinley.ca, mcosgrove@morganmckinley.ie, rcave@morganmckinley.ie, kjarchow@morganmckinley.com, traceyoneill@morganmckinley.ie, mholly@premiergp.com, taraoneill@morganmckinley.ie, gfitzgerald@morganmckinley.ie",
  ...config
  
};  



// WEBPACK FOOTER //
// ./src/config.js